import React, { FC } from "react";
import RecentCustomersWidget from "./RecentCustomersWidget";
import ActiveSubscriptionsWidget from "./ActiveSubscriptionsWidget";
import RecentPaymentsWidget from "./RecentPaymentsWidget";
import DashboardStore from "../DashboardStore";
import ActivityWidget from "./ActivityWidget";
import { ActivityWrapper } from "./DashboardMain.styles";
import NewOrdersWidget from "./NewOrdersWidget";
import ActivityGraphWidget from "./ActivityGraphWidget";
import { observer } from "mobx-react";
import ItemBreakDownWidget from "./ItemBreakDownWidget";
import FundingWidget from "./FundingWidget";
import PaymentBreakDownWidget from "./PaymentBreakDownWidget";
import {
  DashboardTopBar,
  DashboardTopRightSide,
  ItemContentArea,
} from "../../../shared/components";
import {
  AuthService,
  FlexContainer,
  Loader,
} from "@mindmemobile/mm-shared-global";
import { MainOuterCard } from "../../../shared/styles";
import { ItemsStore, RolesAndPermissionStore } from "../../../shared/store";
import { MerchantAccount } from "../../../shared/models";
import { MerchantAccountStore } from "../../../modules/merchantAccounts";

type IProps = {
  dashboardStore: DashboardStore;
  itemStore: ItemsStore;
  merchantAccounts: MerchantAccount[];
  merchantAccountId: string;
  onChangeMerchantAccount: (merchantAccountId: string) => void;
  isMerchantAccountLoading: boolean;
  rolesAndPermissionStore: RolesAndPermissionStore;
  merchantAccountStore: MerchantAccountStore;
  selectedMerchantAccount?: MerchantAccount;
};
const DashboardMain: FC<IProps> = ({
  dashboardStore,
  itemStore,
  merchantAccounts,
  merchantAccountId,
  onChangeMerchantAccount,
  selectedMerchantAccount,
  isMerchantAccountLoading,
  merchantAccountStore,
  rolesAndPermissionStore,
}) => {
  if (!itemStore.countryStore.countryDataLoaded) {
    return <>{new Loader().loaderComponent}</>;
  }
  // Only NMI merchant accounts get the expanded Recent Activity card plus the
  // Subscription Breakdown widget. Fiserv (and anything unresolved) keeps the
  // original Recent Activity + Funding 50/50 row.
  const isNMIMerchantAccount =
    !!selectedMerchantAccount?.isNMIMerchantAccount();
  function renderDetails(node: React.ReactNode, showItemRightContent = true) {
    const content = showItemRightContent ? (
      <DashboardTopRightSide
        showMerchantAccount={true}
        merchantAccountId={merchantAccountId}
        merchantAccounts={merchantAccounts}
        itemStore={itemStore}
        onChangeMerchantAccount={(merchantAccountId: string) => {
          onChangeMerchantAccount(merchantAccountId);
        }}
        showMerchantPortalButton={true}
        showSearchInput={false}
        selectedMerchantAccount={selectedMerchantAccount}
      />
    ) : (
      <></>
    );
    return (
      <>
        <DashboardTopBar
          showSearchInput={true}
          showMerchantAccountNotificationBar={
            merchantAccounts.length === 0 && !isMerchantAccountLoading
          }
          showMerchantAccount={true}
          merchantAccountId={merchantAccountId}
          merchantAccounts={merchantAccounts}
          itemStore={itemStore}
          onChangeMerchantAccount={(merchantAccountId: string) => {
            onChangeMerchantAccount(merchantAccountId);
          }}
          rightContent={<>{content}</>}
          merchantAccountStore={merchantAccountStore}
          rolesAndPermissionStore={rolesAndPermissionStore}
        />
        {AuthService.hasAccount && (
          <ItemContentArea
            node={node}
            itemStore={itemStore}
            showMerchantAccountNotificationBar={merchantAccountStore.hasNotificationBar()}
          />
        )}
      </>
    );
  }

  //if (!merchantAccountId) return <>{new Loader(true).loaderComponent}</>;
  return renderDetails(
    <>
      <ActivityWrapper>
        <div>
          {isNMIMerchantAccount ? (
            <FlexContainer
              className="db-min-width equal-height-row"
              alignItems="stretch"
            >
              <MainOuterCard className="main-card-min-width">
                <ActivityWidget
                  dashboardStore={dashboardStore}
                  merchantAccountId={merchantAccountId}
                  isExpanded={true}
                />
              </MainOuterCard>
              <MainOuterCard width="340px !important">
                <PaymentBreakDownWidget
                  merchantAccountId={merchantAccountId}
                />
              </MainOuterCard>
            </FlexContainer>
          ) : (
            <FlexContainer className="db-min-width">
              <MainOuterCard width="50%" className="main-card-min-width">
                <ActivityWidget
                  dashboardStore={dashboardStore}
                  merchantAccountId={merchantAccountId}
                />
              </MainOuterCard>
              <MainOuterCard width="50%">
                <FundingWidget
                  dashboardStore={dashboardStore}
                  merchantAccountId={merchantAccountId}
                />
              </MainOuterCard>
            </FlexContainer>
          )}
        </div>
        <div>
          <FlexContainer className="db-min-width">
            <MainOuterCard
              width="100% !important"
              height="550px !important"
              className="db-min-height"
            >
              <ActivityGraphWidget
                dashboardStore={dashboardStore}
                merchantAccountId={merchantAccountId}
              />
            </MainOuterCard>
          </FlexContainer>
        </div>

        <div>
          <FlexContainer className="db-min-width">
            <MainOuterCard>
              <NewOrdersWidget
                dashboardStore={dashboardStore}
                merchantAccountId={merchantAccountId}
              />{" "}
            </MainOuterCard>
            <MainOuterCard>
              <ActiveSubscriptionsWidget
                merchantAccountId={merchantAccountId}
                dashboardStore={dashboardStore}
              />
            </MainOuterCard>
          </FlexContainer>
        </div>
        <div>
          <FlexContainer className="db-min-width">
            <MainOuterCard>
              <RecentPaymentsWidget
                merchantAccountId={merchantAccountId}
                dashboardStore={dashboardStore}
                countriesWithState={itemStore.countryStore.countriesWithState}
              />
            </MainOuterCard>
            <MainOuterCard width="340px !important">
              <ItemBreakDownWidget
                dashboardStore={dashboardStore}
                merchantAccountId={merchantAccountId}
              />
            </MainOuterCard>
          </FlexContainer>
        </div>
        <div>
          <FlexContainer className="db-min-width">
            <MainOuterCard>
              <RecentCustomersWidget
                dashboardStore={dashboardStore}
                countriesWithState={itemStore.countryStore.countriesWithState}
              />
            </MainOuterCard>
          </FlexContainer>
        </div>
      </ActivityWrapper>
    </>,
  );
};

export default observer(DashboardMain);
